var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.41,
    height: 20,
    viewBox: "0 0 16.41 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#77708b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.205,23.75A2.057,2.057,0,0,0,16.256,21.7h-4.1A2.057,2.057,0,0,0,14.205,23.75ZM20.359,17.6V12.468c0-3.149-1.672-5.785-4.615-6.482v-.7a1.538,1.538,0,0,0-3.077,0v.7c-2.933.7-4.615,3.323-4.615,6.482V17.6L6,19.647v1.026H22.41V19.647Zm-2.051,1.026H10.1V12.468c0-2.544,1.549-4.615,4.1-4.615s4.1,2.072,4.1,4.615Z",
    transform: "translate(-6 -3.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications-icon.bb74e61a502ec6cf6cd30c41575a2559.svg";
export { ForwardRef as ReactComponent };